import { render, staticRenderFns } from "./Carti.vue?vue&type=template&id=356a99c7&"
import script from "./Carti.vue?vue&type=script&lang=js&"
export * from "./Carti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports